import React, { Component } from "react";
import CartContext from "./CartContext";
import { Carousel, Button, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Showcase } from "./Showcase";
import { DemoLinks } from "./Home";
import { ECommerceFeatures, ECommercePricing } from "./Pricing";
import { DigitalMarketingPricing } from "./Pricing";

import {
  RetailPosModule,
  InventoryModule,
  PurchasesModule,
  OrdersManagementModule,
  DeliveryManagementModule,
  PackagingManagementModule,
  CrmModule,
  HrmModule,
  AccountingModule,
  ReportsModule,
  ErpRetail,
  LeadsManagementModule,
  CouponsManagementModule,
  ECommerceB2CModule,
  ECommerceB2BModule,
  QuoteManagementModule,
  KioskModule,
  QrcodeModule,
  DemoButton,
  ProjectsModule,
  SalesOrderModule,
  MarketingModule,
} from "./CommonModules";
import { ECommerceB2CRetail } from "./ECommerceB2cRetail";

export class SolutionECommerce extends Component {
  static contextType = CartContext;

  constructor(props) {
    super(props);
    this.state = {
      index: 0,
      stores: [
        // {
        //   name: "bagfactory.png",
        //   title: "Bag Factory",
        //   url: "https://bagfactory.elasticcart.com",
        // },
        {
          name: "grocery.png",
          title: "Grocery Store",
          url: "https://supermarket.elasticcart.com",
        },
        {
          name: "fashions.png",
          title: "Fashion Shop",
          url: "https://fashion.elasticcart.com",
        },
        {
          name: "fruitsandvegetables.png",
          title: "Fruits and Vegetables Shop",
          url: "https://fruitsandvegetables.elasticcart.com",
        },
        {
          name: "furniture.png",
          title: "Furniture Shop",
          url: "https://furniture.elasticcart.com",
        },
        {
          name: "jewelry.png",
          title: "Jewellery Shop",
          url: "https://jewellery.elasticcart.com",
        },
        {
          name: "electronics.png",
          title: "Electronics Shop",
          url: "https://electronics.elasticcart.com",
        },
        {
          name: "mobileshop.png",
          title: "Mobile Shop",
          url: "https://mobileshop.elasticcart.com",
        },
        {
          name: "floral.png",
          title: "Floral Store",
          url: "https://floral.elasticcart.com",
        },
        {
          name: "bakery.png",
          title: "Bakery Shop",
          url: "https://bakery.elasticcart.com",
        },
        {
          name: "books.png",
          title: "Books Shop",
          url: "https://books.elasticcart.com",
        },
        {
          name: "pharma.png",
          title: "Pharmacy Shop",
          url: "https://pharma.elasticcart.com",
        },
        {
          name: "sarees.png",
          title: "Boutique and Sarees Shop",
          url: "https://sarees.elasticcart.com",
        },
        {
          name: "sports.png",
          title: "Sports Shop",
          url: "https://sports.elasticcart.com",
        },
        {
          name: "meatshop.png",
          title: "Meat Shop",
          url: "https://restaurant.elasticcart.com",
        },
        {
          name: "machinery.png",
          title: "Tools and Machinery Store",
          url: "https://machinery.elasticcart.com",
        },
        {
          name: "aquiarium.png",
          title: "Aquarium Shop",
          url: "https://aquiarium.elasticcart.com",
        },
      ],
    };
  }

  handleSelect = (selectedIndex) => {
    this.setState({ index: selectedIndex });
  };

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    if (this.context.EcSettings.length === 0) {
      return <></>;
    }
    return (
      <div class="container-fluid py-3">
        <div class="container">
          <div class="row gx-4 py-1">
            <div class="col-lg-12">
              <div>
                <h6 class="text-primary text-uppercase">Solution</h6>
                <h2 className="display-6 text-dark">
                  Premium ECommerce Solution for B2C/B2B
                </h2>
                <p className="text-muted lead">
                  We provide a comprehensive eCommerce solution B2C/B2B that
                  empowers you to manage your online business with ease. Our
                  platform covers B2C and B2B use cases, allowing you to cater
                  to a wide range of customers. With our user-friendly
                  interface, you can easily manage your online business, manage
                  products, process orders, generate leads, and track inventory.
                  Our solution is designed to help you grow your business and
                  reach more customers online.
                  <br />
                </p>
              </div>
              <DemoButton></DemoButton>
              <div className="col-lg-12 mb-lg-5">
                <video
                  controls
                  height="400px"
                  autoPlay
                  muted
                  loop
                  width="100%"
                  // className="rounded shadow"
                  aria-label="POS software demo video"
                >
                  <source
                    src={
                      this.context.GetEcSettingValueByName(
                        "StorageBlobImageUrl"
                      ) + "ECommerceRetailB2cVideo.mp4"
                    }
                    type="video/mp4"
                  />
                  Your browser does not support the video tag.
                </video>
              </div>
              <div className="col-12 col-lg-8 text-center mx-auto mb-4">
                <Carousel
                  fade
                  activeIndex={this.state.index}
                  onSelect={this.handleSelect}
                >
                  {this.state.stores.map((store, idx) => (
                    <Carousel.Item key={idx} interval={3000}>
                      <div className="bg-warning CornersRoundedMedium pb-5 px-5 text-center border">
                        <h3 className="text-black mb-3">{store.title}</h3>
                        <h6 className="text-white mb-3">
                          Click below to see Demo
                        </h6>
                        <a
                          href={store.url}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            src={`https://ecprdstorage01.blob.core.windows.net/elasticcart/images/${store.name}`}
                            alt={store.title}
                            className="img-fluid rounded"
                            style={{
                              maxHeight: "450px",
                              objectFit: "contain",
                            }}
                          />
                        </a>
                      </div>
                    </Carousel.Item>
                  ))}
                </Carousel>
              </div>
              <DemoButton></DemoButton>

              <div className="col-lg-12">
                <div className="bg-light p-4 rounded shadow-sm">
                  {/* POS Feature Sections */}
                  <FeatureSection
                    title="Features & Benefits"
                    items={[
                      "✔ Free SSL and Custom domain",
                      "✔ Premium & Custom Themes",
                      "✔ OTP Authentication (SMS/Email)",
                      "✔ Payment Gateway, COD, Manual UPI",
                      "✔ Product Variants, Multi-Image, Video",
                      "✔ Discounts, Wishlists, Smart Cart",
                      " customer visited products",
                      "✔ Product Bundles, Gift Cards",
                      "✔ Vlogs & Blogs Integration",
                      "✔ Marketing ads, SEO, and Social Media",
                      "✔ Notifications: Email, WhatsApp, Abandoned Cart",
                      "✔ Multi-Store, Multi-Vendor, Multi-Currency",
                      "✔ Product Reviews, Ratings, and Comments",
                      "✔ Analytics, Reports, Customer Dashboard",
                      "✔ 12+ ERP modules to manage end-to-end use cases",
                    ]}
                  />
                </div>
              </div>

              {/* <div className="row g-4">
                <div className="col-12 col-lg-4">
                  <div className="bg-light p-4 rounded h-100 ">
                    <DemoButton></DemoButton>

                    <h5 className="text-dark mb-3">Key Features</h5>
                    <ul className="list-unstyled small text-muted">
                      <li>✔ Free SSL and Custom domain</li>
                      <li>✔ Premium & Custom Themes</li>
                      <li>✔ OTP Authentication (SMS/Email)</li>
                      <li>✔ Payment Gateway, COD, Manual UPI</li>
                      <li>✔ Product Variants, Multi-Image, Video</li>
                      <li>✔ Discounts, Wishlists, Smart Cart</li>
                      <li> customer visited products</li>
                      <li>✔ Product Bundles, Gift Cards</li>
                      <li>✔ Vlogs & Blogs Integration</li>
                      <li>✔ Marketing ads, SEO, and Social Media</li>
                      <li>✔ Notifications: Email, WhatsApp, Abandoned Cart</li>
                      <li>✔ Multi-Store, Multi-Vendor, Multi-Currency</li>
                      <li>✔ Product Reviews, Ratings, and Comments</li>
                      <li>✔ Analytics, Reports, Customer Dashboard</li>
                      <li>✔ 12+ ERP modules to manage end-to-end use cases</li>
                    </ul>
                  </div>
                </div>
              </div> */}

              {/* ERP Modules Section */}
              <section className="container my-5">
                <h5 className="display-6 text-dark mb-4">
                  Explore Integrated ERP Modules That Power Your Business
                </h5>
                <Row className="g-3">
                  {[
                    ECommerceB2CModule,
                    ECommerceB2BModule,
                    KioskModule,
                    QrcodeModule,
                    InventoryModule,
                    PurchasesModule,
                    MarketingModule,
                    LeadsManagementModule,
                    QuoteManagementModule,
                    SalesOrderModule,
                    RetailPosModule,
                    OrdersManagementModule,
                    PackagingManagementModule,
                    DeliveryManagementModule,
                    CrmModule,
                    CouponsManagementModule,
                    HrmModule,
                    AccountingModule,
                    ProjectsModule,
                    ReportsModule,
                  ].map((Module, index) => (
                    <Col md={6} lg={6} key={index}>
                      <div className="bg-light p-3 rounded shadow-sm h-100 hover-shadow">
                        <Module />
                      </div>
                    </Col>
                  ))}
                </Row>
              </section>
              <DemoButton></DemoButton>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
// Reusable FeatureSection component
const FeatureSection = ({ title, items }) => (
  <div className="mb-4">
    <h5 className="display-6 fw-semibold">{title}</h5>

    <ul className="mb-0 ps-3">
      <Row>
        {items.map((item, idx) => (
          <Col xs={6} key={idx}>
            {/* <li key={idx} className="mb-2">
              
            </li> */}
            {/* <li key={idx}>{item}</li> */}
            <span className="mb-5">{item}</span>
          </Col>
        ))}
      </Row>
    </ul>
  </div>
);
